import { isFunction as lo_isFunction } from 'es-toolkit';
const now = () => performance.now();
const noop = () => {};

export class Timer extends EventTarget {
    count: number = 0;

    #running: boolean = false;
    #last: number = 0;
    #interval: number = 1000;
    #frame: number = 0;
    #fn: Function = noop;
    #fireFn: Function = noop;


    constructor(fn?: Function, interval = 1000) {
        super();
        this.#last = now();
        this.#fn = fn || noop;
        this.#interval = interval;
        this.#fireFn = (dt: number) => {
            if (lo_isFunction(this.#fn)) {
                this.#fn.call(self, dt);
            }
        };
    }

    get interval(): number {
        return this.#interval;
    }

    set interval(value: number) {
        this.#interval = value;
    }

    start(fn?: Function): void {
        if (this.#running) {
            return;
        }

        if (lo_isFunction(fn)) {
            this.#fn = fn;
        }

        this.#running = true;
        this.#last = now();
        this.#frame = requestAnimationFrame(() => this.#tick());
        this.dispatchEvent(new Event('start'));
    }

    stop(): void {
        this.#running = false;

        if (this.#frame !== 0) {
            cancelAnimationFrame(this.#frame);
        }

        this.#frame = 0;
        this.dispatchEvent(new Event('stop'));
    }

    reset() {
        this.#frame = 0;
        this.dispatchEvent(new Event('reset'));
    }

    destroy(): void {
        this.stop();
        this.#fn = noop;
        this.#fireFn = noop;
    }

    #tick() {
        this.#frame = requestAnimationFrame(() => this.#tick());
        const time = now();
        const dt = time - this.#last;

        if (dt >= this.#interval) {
            this.#last = time;
            this.count++;
            this.#fireFn(dt);
            this.dispatchEvent(new Event('tick'));
        }
    }
}
